import { SelectionType } from "owa-addins-view/lib/utils/navigations/SelectionType";
import { isGroupTableSelected } from "owa-group-utils";
import updateAddinOnItemNavigation from "./updateAddinOnItemNavigation";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export default function updateAddinOnNavigationToEmptyNullReadingPane(): void {
    updateAddinOnItemNavigation(isGroupTableSelected() ? SelectionType.NotSupported : SelectionType.Empty, getModuleContextMailboxInfo());
}
